/**
 * Animations-State-Machine für das Schiff-Hologramm.
 * Verwaltet Rotation, Build-Pose und Laser-Build-Animation.
 */

const ROTATION_SPEED = 0.12;
const POSE_DURATION = 0.5;
const BUILD_ANIM_DURATION = 2.0;
const TWO_PI = Math.PI * 2;
const BUILD_POSE_ANGLE = Math.PI * 1.75;

export class ShipHologramAnimation {
  private _rotAngle = 0;
  private _buildPose = false;
  private _poseStart = 0;
  private _poseEnd = 0;
  private _poseElapsed = 0;
  private _poseResolve: (() => void) | null = null;
  private _buildProgress = -1;
  private _buildElapsed = 0;
  private _buildResolve: (() => void) | null = null;

  get rotAngle(): number { return this._rotAngle; }
  get buildProgress(): number { return this._buildProgress; }

  enterBuildPose(): Promise<void> {
    this._buildPose = true;
    this._poseStart = this._rotAngle;

    const cur = ((this._rotAngle % TWO_PI) + TWO_PI) % TWO_PI;
    let delta = BUILD_POSE_ANGLE - cur;
    if (delta > Math.PI) delta -= TWO_PI;
    if (delta < -Math.PI) delta += TWO_PI;

    this._poseEnd = this._rotAngle + delta;
    this._poseElapsed = 0;
    return new Promise<void>(resolve => { this._poseResolve = resolve; });
  }

  startBuildAnimation(): Promise<void> {
    this._buildProgress = 0;
    this._buildElapsed = 0;
    return new Promise<void>(resolve => { this._buildResolve = resolve; });
  }

  resetPose(): void {
    this._buildPose = false;
    if (this._poseResolve) { this._poseResolve(); this._poseResolve = null; }
  }

  resetBuild(): void {
    this._buildProgress = -1;
    this._buildElapsed = 0;
    if (this._buildResolve) { this._buildResolve(); this._buildResolve = null; }
  }

  updateRotation(dt: number): void {
    if (this._buildPose) {
      if (this._poseElapsed < POSE_DURATION) {
        this._poseElapsed = Math.min(this._poseElapsed + dt, POSE_DURATION);
        const t = this._poseElapsed / POSE_DURATION;
        const ease = 1 - (1 - t) * (1 - t);
        this._rotAngle = this._poseStart + (this._poseEnd - this._poseStart) * ease;
        if (t >= 1 && this._poseResolve) {
          this._poseResolve();
          this._poseResolve = null;
        }
      }
    } else {
      this._rotAngle += dt * ROTATION_SPEED;
    }
  }

  updateBuild(dt: number): void {
    if (this._buildProgress < 0) return;
    this._buildElapsed = Math.min(this._buildElapsed + dt, BUILD_ANIM_DURATION);
    const t = this._buildElapsed / BUILD_ANIM_DURATION;
    this._buildProgress = t;
    if (t >= 1 && this._buildResolve) {
      this._buildResolve();
      this._buildResolve = null;
    }
  }
}
